<div class="sidebar-backdrop" (click)="sidebarService.toogle()" *ngIf="sidebarService.isExpanded()"></div>
<aside class="sidebar" [class.expanded]="sidebarService.isExpanded()">
        <div class="sidebar-logo">
                <img class="logo-img logo-light" src="/assets/images/logo-guai-black.png" alt="Guai Insurtech">
                <img class="logo-img logo-dark" src="/assets/images/logo-guai.png" alt="Guai Insurtech">
        </div>

        <ng-template #menuItem let-item>
                <a pRipple class="nav-link p-menuitem-link"
                        [routerLink]="item.routerLink || item.link"
                        [routerLinkActive]="'p-menuitem-link-active'"
                        [routerLinkActiveOptions]="{exact: true}"
                        [attr.title]="sidebarService.isExpanded() ? null : item.label"
                        (click)="item.items && onGroupClick(item)">
                        <span class="p-menuitem-icon" [class]="item.icon"></span>
                        <span class="p-menuitem-text">{{ item.label }}</span>
                        <span *ngIf="item.badge && item.badge !== '0'" class="nav-badge">{{ item.badge }}</span>
                        <i *ngIf="item.items" class="pi pi-angle-right nav-chevron"></i>
                </a>
        </ng-template>

        <nav class="sidebar-nav">
                <ng-container *ngFor="let section of sections; trackBy: trackSection">
                        <div *ngIf="section.label" class="nav-label">{{ section.label }}</div>
                        <p-panelMenu [model]="section.items" styleClass="custom-menu">
                                <ng-template #item let-item>
                                        <ng-container *ngTemplateOutlet="menuItem; context: { $implicit: item }"></ng-container>
                                </ng-template>
                        </p-panelMenu>
                </ng-container>
        </nav>

        <nav class="sidebar-nav sidebar-bottom">
                <p-panelMenu [model]="bottomItems" styleClass="custom-menu">
                        <ng-template #item let-item>
                                <ng-container *ngTemplateOutlet="menuItem; context: { $implicit: item }"></ng-container>
                        </ng-template>
                </p-panelMenu>
        </nav>
</aside>
